module.exports = __webpack_public_path__ + "static/media/back_arrow.834368ef.svg";